import { useEffect } from 'react';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { EmptyIllustration } from '@interxfi/design-system/components/illustration/empty-illustration';
import { TextButton } from '@interxfi/design-system/components/link/text-link/text-button';
import AlertIcon from '@interxfi/design-system/icons/react/icon-alert';

export function UnexpectedError({ error, info }: ErrorComponentProps) {
  useEffect(() => {
    console.warn('Unexpected Error:', { error, info });
  }, [error, info]);

  return (
    <EmptyIllustration icon={<AlertIcon aria-hidden />} message="Unexpected Error" subMessage="Sorry, something went wrong.">
      <TextButton
        onClick={() => {
          window.location.reload();
        }}
      >
        Refresh
      </TextButton>
    </EmptyIllustration>
  );
}
